import React from 'react';
import { Badge, Button, Card } from 'react-bootstrap';
import { ArrowUpRightCircle } from 'react-bootstrap-icons';
import CopyableResponse from './CopyableResponse';
import { flowPositionVariant } from '../../helpers/conversationBank';

const ConversationBankCard = ({ result, placeholderContext, onOpen, onCopied }) => {
  const heading =
    result.flowPosition === 'CONTINUE' && result.possibleCustomerReply
      ? result.possibleCustomerReply
      : result.customerQuestionSituation;

  return (
    <Card className={`cb-card mb-3 border-${flowPositionVariant(result.flowPosition)}`}>
      <Card.Body className="p-3">
        <div className="d-flex flex-wrap align-items-center mb-2">
          <Badge variant={flowPositionVariant(result.flowPosition)} className="mr-2 mb-1">
            {result.flowPosition}
          </Badge>
          <span className="smallFont text-muted mb-1">{result.topicCategory}</span>
        </div>
        <div className="cb-customer-words mb-3">{heading}</div>
        {result.flowPosition === 'CONTINUE' && result.possibleCustomerReply && (
          <div className="smallFont text-muted mb-2">From: {result.customerQuestionSituation}</div>
        )}
        <div className="mb-3">
          <div className="smallFont text-muted mb-1">Recommended language</div>
          <CopyableResponse
            text={result.recommendedLanguage}
            placeholderContext={placeholderContext}
            onCopied={() =>
              onCopied &&
              onCopied({
                record: result._id,
                branch: result.matchingBranchId,
                responseType: result.copyResponseType
              })
            }
          />
        </div>
        <Button
          variant="dark"
          className="cb-open-btn w-100"
          onClick={() => onOpen(result)}
        >
          Open Full Flow
          <ArrowUpRightCircle className="ml-2" />
        </Button>
      </Card.Body>
    </Card>
  );
};

export default ConversationBankCard;
